'use strict';

function init() {
  for (let overlayElement of document.querySelectorAll('.overlay-message')) {
    makeCloseable(overlayElement);
  }
}

function makeCloseable(overlayElement) {
  if (!overlayElement)
    return;

  let closeButton = overlayElement.querySelector('.close-overlay');

  if (closeButton) {
    closeButton.classList.remove('u-hidden');

    closeButton.addEventListener('click', function(event) {
      event.preventDefault();
      killOverlay(overlayElement);
    });
  }
}

function killOverlay(overlayElement) {
  if (!overlayElement)
    return;

  if (overlayElement.classList.contains('overlay-message--timeout')) {
    let overlayMessageAudible = document.querySelector('.timeout-message-hidden');
    if (overlayMessageAudible) {
      overlayMessageAudible.parentNode.removeChild(overlayMessageAudible);
    }
  }

  overlayElement.parentNode.removeChild(overlayElement);
}

if ('querySelector' in document) {
  init();
}
